import React from 'react';
import Header from '../../../../Header/Header';
import SmsMessageLog from './SmsMessageLog';
import Navigationbar from '../../../../Navigationbar/Navigationbar';

const SmsMessageLogWrapper = (props) => {

    const { themeSelected } = props;

    return (
        <div className='container-fluid m-1'>
            <Header {...props} />
            <Navigationbar {...props} />
            <SmsMessageLog className='mt-3' themeSelected={themeSelected} />
        </div>
    )
}

export default SmsMessageLogWrapper;